'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _priceString = require('helpers/priceString');

var _priceString2 = _interopRequireDefault(_priceString);

var _emailStyleTools = require('helpers/emailStyleTools');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Total(props) {
  var components = props.components,
      price = props.price,
      currencyCode = props.currencyCode,
      selectedCurrencyFormat = props.selectedCurrencyFormat,
      t = props.t;


  var styleTotalContainer = {
    backgroundColor: components.RailCardTotalContainer.backgroundColor
  };
  var styleRailCardTotalLabel = (0, _emailStyleTools.textStyles)(components, 'RailCardTotalLabel');
  var styleRailCardTotalValue = (0, _emailStyleTools.textStyles)(components, 'RailCardTotalValue');

  return _react2.default.createElement(
    'table',
    { style: { borderCollapse: 'collapse', width: '100%' }, 'data-component': 'Total' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: (0, _extends3.default)({}, styleTotalContainer, { padding: '10px', verticalAlign: 'top', textAlign: 'right' }) },
          _react2.default.createElement(
            'span',
            { style: styleRailCardTotalLabel },
            t('rail.total'),
            ': '
          ),
          _react2.default.createElement(
            'span',
            { style: styleRailCardTotalValue },
            (0, _priceString2.default)(selectedCurrencyFormat, price, currencyCode)
          )
        )
      )
    )
  );
}

var mstp = function mstp(state) {
  return {
    components: state.templateApplication.templates.currentTemplate.components,
    selectedCurrencyFormat: state.rendering.shopOptions.currencyFormat || state.templateApplication.templates.currentTemplate.currencyFormat
  };
};

exports.default = (0, _reactI18next.translate)()((0, _reactRedux.connect)(mstp)(Total));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/RailCard/Email/RailCardTotal.jsx
// module id = 1552
// module chunks = 0